import React, { Component } from 'react'
import PropTypes from 'prop-types'

import {
  fetchLocations,
  showUpdateLocationForm,
  deleteLocation,
  showLocationCalendar,
  fetchBookings,
  moveUp,
  moveDown,
  updateFilter,
  changePage
} from '../actions/locations.js'
import { fetchBuildings } from '../actions/buildings.js'
import { fetchCompanies } from '../actions/companies.js'

import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

import { Card, CardText } from 'material-ui/Card'
import { Table, TableBody, TableHeader, TableHeaderColumn, TableRow, TableRowColumn } from 'material-ui/Table'
import RaisedButton from 'material-ui/RaisedButton'
import FlatButton from 'material-ui/FlatButton'
import CircularProgress from 'material-ui/CircularProgress'
import SelectField from 'material-ui/SelectField'
import MenuItem from 'material-ui/MenuItem'
import Paper from 'material-ui/Paper'
import ConfirmButton from 'material-ui-confirm-button'
import Delete from 'material-ui/svg-icons/action/delete'
import Edit from 'material-ui/svg-icons/image/edit'
import DateRange from 'material-ui/svg-icons/action/date-range'
import NavigationArrowDropUp from 'material-ui/svg-icons/navigation/arrow-drop-up'
import NavigationArrowDropDown from 'material-ui/svg-icons/navigation/arrow-drop-down'
import BigCalendar from 'react-big-calendar'
import Pagination from 'material-ui-pagination'

import 'react-big-calendar/lib/css/react-big-calendar.css'
import 'rc-calendar/assets/index.css'

import AddLocation from '../components/locations/AddLocation'
import LocationCalendar from '../components/locations/LocationCalendar'

import moment from 'moment'

const style = {
  margin: 0
}

const iconStyle = {
  margin: 0,
  padding: 0,
  minWidth: 0,
  width: 50
}

BigCalendar.setLocalizer(BigCalendar.momentLocalizer(moment))

class Locations extends Component {
  static defaultProps = {
    filter: {
      buildingId: ' ',
      companyId: ' '
    },
    pageNumber: 1,
    itemsPerPage: 50,
    paginationDisplay: 10
  }

  static propTypes = {
    dispatch: PropTypes.func.isRequired
  }

  componentDidMount() {
    const { dispatch } = this.props
    this.fetchPageLocations()
    dispatch(fetchBuildings())
    dispatch(fetchCompanies())
    document.title = 'Locations - Admin - Better Spaces'
  }

  componentDidUpdate() {
    if (this.props.pageOrFilterChanged) {
      this.fetchPageLocations()
    }
  }

  fetchPageLocations() {
    const { dispatch } = this.props
    dispatch(
      fetchLocations(this.props.filter, (this.props.pageNumber - 1) * this.props.itemsPerPage, this.props.itemsPerPage)
    )
  }

  updateFilter(name, event, index, value) {
    const { dispatch } = this.props
    dispatch(updateFilter(name, value))
  }

  showAddLocationForm() {
    const { dispatch } = this.props
    dispatch(showUpdateLocationForm({}))
  }

  updateLocation(location) {
    const { dispatch } = this.props
    dispatch(showUpdateLocationForm(location))
  }

  deleteLocation(location) {
    const { dispatch } = this.props
    dispatch(deleteLocation(location))
  }

  showCalendar(location) {
    const { dispatch } = this.props
    dispatch(fetchBookings(location))
    dispatch(showLocationCalendar(location))
  }

  moveUp(location) {
    const { dispatch } = this.props
    dispatch(moveUp(location))
  }

  moveDown(location) {
    const { dispatch } = this.props
    dispatch(moveDown(location))
  }

  onPageChanged(newPageNumber) {
    const { dispatch } = this.props
    if (newPageNumber != this.props.pageNumber) dispatch(changePage(newPageNumber))
  }

  render() {
    if (this.props.locationsFetched && this.props.buildingsFetched && this.props.companiesFetched) {
      if (this.props.locations) {
        var locations = this.props.locations

        return (
          <div>
            <LocationCalendar />
            <AddLocation />
            {this.props.role.length > 5 && this.props.role.charAt(5) == '2' ? (
              <RaisedButton
                label='Add Location'
                primary={true}
                style={style}
                onClick={this.showAddLocationForm.bind(this)}
              />
            ) : (
              <div />
            )}

            <div
              className='hidden-xs hidden-sm' /* style={{float: 'left', width: '100%', paddingTop: '10px', paddingBottom: '10px'}} */
            >
              <Paper style={style} zDepth={1}>
                <div style={{ margin: '10px' }}>
                  <br />
                  Filter by:&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <br />
                  <SelectField
                    floatingLabelText='Building'
                    value={this.props.filter.buildingId}
                    onChange={this.updateFilter.bind(this, 'buildingId')}>
                    <MenuItem value=' ' primaryText='All Buildings' />
                    {this.props.buildings.map((building, index) => (
                      <MenuItem value={building._id} primaryText={building.name} />
                    ))}
                  </SelectField>
                  &nbsp;&nbsp;&nbsp;
                  <SelectField
                    floatingLabelText='Company'
                    value={this.props.filter.companyId}
                    onChange={this.updateFilter.bind(this, 'companyId')}>
                    <MenuItem value=' ' primaryText='All Companies' />
                    {this.props.companies.map((company, index) => (
                      <MenuItem value={company._id} primaryText={company.name} />
                    ))}
                  </SelectField>
                  <br />
                </div>
              </Paper>
            </div>
            <br />
            <br />
            <div>
              <Pagination
                total={Math.ceil(this.props.totalLocationsAfterFilters / this.props.itemsPerPage)}
                current={this.props.pageNumber}
                display={this.props.paginationDisplay}
                onChange={this.onPageChanged.bind(this)}
              />
            </div>
            <Table selectable={false} style={{ tableLayout: 'auto' }} fixedHeader={false}>
              <TableHeader displaySelectAll={false} adjustForCheckbox={false}>
                <TableRow>
                  <TableHeaderColumn style={{ width: '1%' }} />
                  <TableHeaderColumn style={{ width: '1%' }} />
                  <TableHeaderColumn style={{ width: '3%' }}>ID</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '10%' }}>Name</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '3%' }}>Capacity</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '3%' }}>Company</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '3%' }}>Building</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '50%' }}>Description</TableHeaderColumn>
                  <TableHeaderColumn style={{ width: '10%' }} />
                </TableRow>
              </TableHeader>
              <TableBody displayRowCheckbox={false}>
                {locations.map((location, index) => (
                  <TableRow>
                    <TableRowColumn>
                      {location.orderIndex > 0 ? (
                        <FlatButton
                          id='move_up'
                          icon={<NavigationArrowDropUp />}
                          style={iconStyle}
                          primary={true}
                          onClick={this.moveDown.bind(this, location)}
                        />
                      ) : (
                        ''
                      )}
                    </TableRowColumn>
                    <TableRowColumn>
                      {location.orderIndex < this.props.locations.length - 1 ? (
                        <FlatButton
                          id='move_down'
                          icon={<NavigationArrowDropDown />}
                          style={iconStyle}
                          primary={true}
                          onClick={this.moveUp.bind(this, location)}
                        />
                      ) : (
                        ''
                      )}
                    </TableRowColumn>
                    <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                      {location.orderIndex + 1}
                    </TableRowColumn>
                    <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                      {location.name}
                    </TableRowColumn>
                    <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                      {location.capacity}
                    </TableRowColumn>
                    <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                      {location.company ? location.company.name : ''}
                    </TableRowColumn>
                    <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                      {location.building ? location.building.name : ''}
                    </TableRowColumn>
                    <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '4%' }}>
                      {location.description}
                    </TableRowColumn>
                    {this.props.role.length > 5 && this.props.role.charAt(5) == '2' ? (
                      <TableRowColumn style={{ wordWrap: 'break-word', whiteSpace: 'normal', width: '3%' }}>
                        <FlatButton
                          id='show_calendar'
                          icon={<DateRange />}
                          style={iconStyle}
                          primary={true}
                          onClick={this.showCalendar.bind(this, location)}
                        />
                        <FlatButton
                          icon={<Edit />}
                          style={iconStyle}
                          primary={true}
                          onClick={this.updateLocation.bind(this, location)}
                        />
                        <ConfirmButton
                          key={location._id}
                          isFlat={true}
                          style={iconStyle}
                          icon={<Delete />}
                          confirmMessage='	&#10004;'
                          cancelMessage='X'
                          secondary={true}
                          onSubmit={this.deleteLocation.bind(this, location)}
                        />
                      </TableRowColumn>
                    ) : (
                      <TableRowColumn />
                    )}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
            <div>
              <Pagination
                total={Math.ceil(this.props.totalLocationsAfterFilters / this.props.itemsPerPage)}
                current={this.props.pageNumber}
                display={this.props.paginationDisplay}
                onChange={this.onPageChanged.bind(this)}
              />
            </div>
          </div>
        )
      } else {
        return (
          <div>
            <AddLocation />
            <RaisedButton
              label='Add Location'
              primary={true}
              style={style}
              onClick={this.showAddLocationForm.bind(this)}
            />
            <Card style={{ width: '100%', height: '100%' }}>
              <CardText style={{ position: 'relative', width: '100%', height: '100%' }}>No Location</CardText>
            </Card>
          </div>
        )
      }
    } else {
      return (
        <Card style={{ width: '100%', height: '100%' }}>
          <CardText style={{ position: 'relative', width: '100%', height: '100%' }}>
            <CircularProgress size={80} thickness={5} style={{ marginLeft: '50%' }} />
          </CardText>
        </Card>
      )
    }
  }
}

const mapStateToProps = state => {
  const { isFetching } = state.locationsReducer

  if (isFetching) {
    return {
      isFetching
    }
  } else {
    return {
      ...state.locationsReducer,
      role: state.usersReducer.role
    }
  }
}

export default withRouter(connect(mapStateToProps)(Locations))



// WEBPACK FOOTER //
// ./src/containers/Locations.js